import { TableColumn } from "components/StentorUIComponents";
import { GetAppsListStatus } from "generated/graphql";

export type ColumnIDs = "app_name" | "created_date" | "last_modified" | "submitter" | "action" | "notes";

export type AppStatus =
    "Cancelled" |
    "Archived" |
    "Live" |
    "Ready for Install" |
    "In Review" |
    "Under Review" |
    "Submitted For Review" |
    "Submitted for Review" |
    "Requires Attention" |
    "Incomplete" |
    "Other";

export type AppsTableListItem = {
    appId: string;
    smallIcon?: string;
    status?: GetAppsListStatus;
    name: string;
}

export type StatusAmountList = {
    name: string;
    value: number;
    color: string;
};

export type AppsTableData = {
    appId: string;
    appIcon: string;
    appName: string;
    createdDate: string;
    lastModifiedDate: string;
    submitter: string;
    status: string;
    notes: string;
}

export interface AppsTableColumn extends TableColumn {
    id: ColumnIDs;
}

export const TABLE_COLUMN_HEADER_LABELS: {
    readonly [key in ColumnIDs]: string;
} = {
    app_name: "App Name",
    created_date: "Created Date",
    last_modified: "Last modified",
    submitter: "Submitter",
    action: "Action",
    notes: "Notes",
};

export const DEFAULT_COLUMNS: ColumnIDs[] = ["app_name", "last_modified", "submitter", "action", "notes"];
